// extracted by mini-css-extract-plugin
module.exports = {"Banner":"Banner_Banner__u6WCM","slideInFromBottom":"Banner_slideInFromBottom__zYSAw"};